import { useTranslation } from 'react-i18next';

import CreativeMap from '../components/CreativeMap';

export default function CreativesMap() {
  const { t } = useTranslation();

  return (
    <div className="container py-8 space-y-6 mt-32">
      <div className="space-y-2">
        <h1 className="text-3xl md:text-4xl font-bold text-primary-text">
          {t('talentMap.findTalentsNearYou')}
        </h1>
        <p className="text-lg text-primary-text">
          {t('talentMap.discoverProfessionals')}
        </p>
      </div>

      <CreativeMap />

      <div className="grid md:grid-cols-3 gap-6 mt-8">
        <div className="bg-card-bg card-hover p-6 rounded-lg">
          <h3 className="text-lg font-semibold mb-2 text-primary-text">
            {t('talentMap.filterBySkills.title')}
          </h3>
          <p className="text-secondary-text">
            {t('talentMap.filterBySkills.description')}
          </p>
        </div>

        <div className="bg-card-bg card-hover p-6 rounded-lg">
          <h3 className="text-lg font-semibold mb-2 text-primary-text">
            {t('talentMap.localCollaboration.title')}
          </h3>
          <p className="text-secondary-text">
            {t('talentMap.localCollaboration.description')}
          </p>
        </div>

        <div className="bg-card-bg card-hover p-6 rounded-lg">
          <h3 className="text-lg font-semibold mb-2 text-primary-text">
            {t('talentMap.verifiedProfessionals.title')}
          </h3>
          <p className="text-secondary-text">
            {t('talentMap.verifiedProfessionals.description')}
          </p>
        </div>
      </div>
    </div>
  );
}
